
export default {
  name: 'AppFooter',
}
